export default __webpack_public_path__ + "static/15-c229a58dc88962984f2c1bd83aedbd34.jpg";